import { KText } from '@/ui-library/components';
import {
  AssociatedRequisition,
  CreditedTo,
  DepartmentName,
  HiredBy,
  Jobname,
  NameCell,
  OfficeNames,
  SourceName,
  TimeToHire,
} from '../cells/HireDrilldownCells';

const renderDrilldownHeader = (title: string) => () => (
  <KText size="sm-medium" color="secondary-900" textTransform="none">
    {title}
  </KText>
);

export const useHireDrilldownConfig = ({
  drilldownHeading = 'Hires',
  onSort: _onSort = () => {},
  currentSort: _currentSort = {},
}) => {
  const getColumnConfig = () => {
    const columnsMap = {
      applicantName: {
        title: 'Applicant name',
        columnConfig: false,
        Header: renderDrilldownHeader('Applicant name'),
        minWidth: 200,
        accessor: 'candidate_name',
        sort: true,
        Cell: ({ row }) => NameCell(row),
      },
      timeToHire: {
        title: 'Time to hire',
        Header: renderDrilldownHeader('Time to hire'),
        minWidth: 200,
        accessor: 'time_to_hire',
        sort: true,
        Cell: ({ row }) => TimeToHire(row),
      },
      sourceName: {
        title: 'Source',
        Header: renderDrilldownHeader('Source'),
        minWidth: 200,
        accessor: 'appl_contact_source',
        sort: true,
        Cell: ({ row }) => SourceName(row),
      },
      creditedTo: {
        title: 'Credited to',
        Header: renderDrilldownHeader('Credited to'),
        minWidth: 200,
        accessor: 'appl_credited_to',
        sort: true,
        Cell: ({ row }) => CreditedTo(row),
      },
      associatedRequisition: {
        title: 'Associated requisition (Req ID & Role name)',
        Header: renderDrilldownHeader(
          'Associated requisition (Req ID & Role name)'
        ),
        minWidth: 220,
        accessor: 'hire_requisition_code',
        sort: true,
        Cell: ({ row }) => AssociatedRequisition(row),
      },
      hiredBy: {
        title: 'Hired by',
        Header: renderDrilldownHeader('Hired by'),
        minWidth: 180,
        accessor: 'hired_by',
        sort: true,
        Cell: ({ row }) => HiredBy(row),
      },
      jobName: {
        title: 'Job names',
        Header: renderDrilldownHeader('Job names'),
        minWidth: 200,
        accessor: 'job_name',
        sort: true,
        Cell: ({ row }) => Jobname(row),
      },
      department: {
        title: 'Department',
        Header: renderDrilldownHeader('Department'),
        minWidth: 200,
        accessor: 'department_name',
        sort: true,
        Cell: ({ row }) => DepartmentName(row),
      },
      officeNames: {
        title: 'Offices',
        Header: renderDrilldownHeader('Offices'),
        minWidth: 220,
        accessor: 'office_name',
        sort: true,
        Cell: ({ row }) => OfficeNames(row),
      },
    };

    const commonRequisitionHiredByJobDeptOffice = [
      columnsMap.associatedRequisition,
      columnsMap.hiredBy,
      columnsMap.jobName,
      columnsMap.department,
      columnsMap.officeNames,
    ];

    switch (drilldownHeading) {
      case 'Hires':
      case 'Time to Hire':
      case 'Hire Trend':
      case 'Average Time to Hire':
        return [
          columnsMap.applicantName,
          columnsMap.timeToHire,
          columnsMap.sourceName,
          columnsMap.creditedTo,
          ...commonRequisitionHiredByJobDeptOffice,
        ];

      case 'Hires by department':
      case 'Hires by Department':
        return [
          columnsMap.applicantName,
          columnsMap.timeToHire,
          columnsMap.sourceName,
          columnsMap.creditedTo,
          columnsMap.associatedRequisition,
          columnsMap.hiredBy,
          columnsMap.jobName,
          columnsMap.officeNames,
        ];

      case 'Hire by source (on application)':
      case 'Hire by Source (on application)':
        return [
          columnsMap.applicantName,
          columnsMap.timeToHire,
          columnsMap.creditedTo,
          ...commonRequisitionHiredByJobDeptOffice,
        ];

      default:
        return [
          columnsMap.applicantName,
          columnsMap.timeToHire,
          columnsMap.sourceName,
          columnsMap.creditedTo,
          ...commonRequisitionHiredByJobDeptOffice,
        ];
    }
  };

  return { columnConfig: getColumnConfig() };
};
